<template>
    <relatorio-page :titulo=" 'Relatório de Log' " :cabecalhoCompleto="true" :exportarExcel="false" :paisagem="true">
        <div>
            <span class="font-weight-bold">
                Período dos logs {{new Date(filtro.dataInicio).ddmmyyyy()}} até {{new Date(filtro.dataFim).ddmmyyyy()}}
            </span>
            <v-divider/>
        </div>
        <v-simple-table id="tabela" dense class="py-2 text-caption" v-if="item.length > 0">
            <template v-slot: default>
                <thead style="background-color: #4A70A8">
                    <tr class="fonte" >
                        <th style="font-size: 100% ; color: white" class="text-left fonte">Tela</th>
                        <th style="font-size: 100% ; color: white" class="text-left fonte">Usuário</th>
                        <th style="font-size: 100% ; color: white" class="text-left fonte">Operação</th>
                        <th style="font-size: 100% ; color: white" class="text-left fonte">Data/Hora</th>
                        <th style="font-size: 100% ; color: white" class="text-left fonte">Descrição</th>
                        <th style="font-size: 100% ; color: white" class="text-left fonte">IP</th>
                    </tr>
                </thead>
                <tbody v-for="(item, index) in item" :key="index">
                    <tr class="fonte" :style=" index % 2 === 0 ? 'background-color: gainsboro' : 'background-color: White'">
                        <td class="text-left" style="font-size: 100%">{{item.tela}}</td>
                        <td class="text-left" style="font-size: 100%">{{item.usuario}}</td>
                        <td class="text-left" style="font-size: 100%">{{item.operacao}}</td>
                        <td class="text-left" style="font-size: 100%">{{new Date(item.dataHora).timeddmmyyyy()}}</td>
                        <td class="text-left" style="font-size: 100%">{{item.descricao}}</td>
                        <td class="text-left" style="font-size: 100%">{{item.ip}}</td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </relatorio-page>
</template>

<script>
import UsuarioService from '../../../core/services/geral/UsuarioService';
export default {
    
    data: () => ({
        item:{
            required: true
        },
        filtro:{
            required: true
        },
        overlay: false
    }),
    mounted(){
        this.filtro = this.$route.query;
        this.Carregar();
    },
    methods:{
        Carregar(){
            const service = new UsuarioService();
            this.overlay = true;
            service.RelatorioLog(this.filtro.dataInicio, this.filtro.dataFim, this.filtro.usuarioId, this.filtro.operacao, this.filtro.ordenacao).then(
                res =>{
                    this.item = res.data;
                },
                err => this.$swal('Aviso', err.response.data, 'error')
            ).finally(() =>{
                this.overlay = false;
            })
        }
    }   

}
</script>

<style>

    .fonte{
        font-size: 70%;
    }

</style>